function Q(n) {
  return (t) => n(vn(t) ? t : t.get());
}
function vn(n) {
  return typeof n == "number";
}
function Dn(n) {
  return typeof n == "string";
}
function Pn(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function F(n) {
  return Math.abs(n);
}
function yn(n) {
  return Math.sign(n);
}
function dn(n, t) {
  return F(n - t);
}
function Gn(n, t) {
  if (n === 0 || t === 0 || F(n) <= F(t)) return 0;
  const u = dn(F(n), F(t));
  return F(u / n);
}
function jn(n) {
  return Math.round(n * 100) / 100;
}
function pn(n) {
  return hn(n).map(Number);
}
function tn(n) {
  return n[mn(n)];
}
function mn(n) {
  return Math.max(0, n.length - 1);
}
function bn(n, t) {
  return t === mn(n);
}
function zn(n, t = 0) {
  return Array.from(Array(n - t + 1), (u, e) => t + e);
}
function hn(n) {
  return Object.keys(n);
}
function Nn(n, t) {
  return [n, t].reduce(
    (u, e) => (
      hn(e).forEach((i) => {
        const a = u[i],
          r = e[i],
          l = Pn(a) && Pn(r);
        u[i] = l ? Nn(a, r) : r;
      }),
      u
    ),
    {}
  );
}
function Tn(n, t) {
  return typeof t.MouseEvent < "u" && n instanceof t.MouseEvent;
}
function $n(n, t) {
  const u = { start: e, center: i, end: a };
  function e() {
    return 0;
  }
  function i(g) {
    return a(g) / 2;
  }
  function a(g) {
    return t - g;
  }
  function r(g, f) {
    return Dn(n) ? u[n](g) : n(t, g, f);
  }
  return { measure: r };
}
function gn() {
  let n = [];
  function t(i, a, r, l = { passive: !0 }) {
    let g;
    if ("addEventListener" in i)
      (i.addEventListener(a, r, l), (g = () => i.removeEventListener(a, r, l)));
    else {
      const f = i;
      (f.addListener(r), (g = () => f.removeListener(r)));
    }
    return (n.push(g), e);
  }
  function u() {
    n = n.filter((i) => i());
  }
  const e = { add: t, clear: u };
  return e;
}
function Rn(n, t) {
  const u = gn(),
    e = 1e3 / 60;
  let i,
    a = null,
    r = 0,
    l = 0;
  function g(s) {
    const c = s.document;
    ((i = s),
      u.add(c, "visibilitychange", () => {
        c.hidden && p();
      }));
  }
  function f() {
    (o(), u.clear());
  }
  function h(s) {
    if (!l) return;
    a || ((a = s), n(), n());
    const c = s - a;
    for (a = s, r += c; r >= e; ) (n(), (r -= e));
    const m = r / e;
    (t(m), l && (l = i.requestAnimationFrame(h)));
  }
  function S() {
    l || (l = i.requestAnimationFrame(h));
  }
  function o() {
    l && (i.cancelAnimationFrame(l), (a = null), (r = 0), (l = 0));
  }
  function p() {
    ((a = null), (r = 0));
  }
  return { init: g, destroy: f, start: S, stop: o, update: n, render: t };
}
function Vn(n, t) {
  const u = t === "rtl",
    e = n === "y",
    i = e ? "y" : "x",
    a = e ? "x" : "y",
    r = !e && u ? -1 : 1,
    l = S(),
    g = o(),
    f = e ? "scrollTop" : "scrollLeft";
  function h(s) {
    const { height: c, width: m } = s;
    return e ? c : m;
  }
  function S() {
    return e ? "top" : u ? "right" : "left";
  }
  function o() {
    return e ? "bottom" : u ? "left" : "right";
  }
  function p(s) {
    return s * r;
  }
  return {
    scroll: i,
    cross: a,
    startEdge: l,
    endEdge: g,
    nativeScroll: f,
    getSize: h,
    direction: Q(p),
  };
}
function un(n = 0, t = 0) {
  const u = F(n - t);
  function e(f) {
    return f < n;
  }
  function i(f) {
    return f > t;
  }
  function a(f) {
    return e(f) || i(f);
  }
  function r(f) {
    return a(f) ? (e(f) ? n : t) : f;
  }
  function l(f) {
    return u ? f - u * Math.ceil((f - t) / u) : f;
  }
  return {
    length: u,
    max: t,
    min: n,
    clamp: Q(r),
    pastAnyBound: Q(a),
    pastMaxBound: Q(i),
    pastMinBound: Q(e),
    removeOffset: Q(l),
  };
}
function An(n, t, u) {
  const { clamp: e } = un(0, n),
    i = n + 1;
  let a = r(t);
  function r(o) {
    return u ? F((i + o) % i) : e(o);
  }
  function l() {
    return a;
  }
  function g(o) {
    return ((a = r(o)), S);
  }
  function f(o) {
    return h().set(l() + o);
  }
  function h() {
    return An(n, l(), u);
  }
  const S = { get: l, set: g, add: f, clone: h };
  return S;
}
function qn(n, t, u, e, i, a, r, l, g, f, h, S, o, p, d, s, c) {
  const { cross: m, direction: b } = t,
    y = ["INPUT", "SELECT", "TEXTAREA"],
    E = { passive: !1 },
    x = gn(),
    w = gn(),
    L = un(50, 225).clamp(o.measure(20)),
    D = { mouse: 300, touch: 400 },
    A = { mouse: 500, touch: 600 },
    M = p ? 43 : 25;
  let z,
    C,
    k = !1,
    T = 0,
    P = 0,
    B = !1,
    H = !1,
    V = !1,
    j = !1,
    G = !1;
  function W(v) {
    if (!n) return;
    ((z = v.document), (C = v), i.init(v));
    const I = u;
    x.add(I, "dragstart", (N) => N.preventDefault(), E)
      .add(I, "touchmove", (N) => B && _(N), E)
      .add(I, "touchend", (N) => B && X(N))
      .add(I, "touchstart", nn)
      .add(I, "mousedown", nn)
      .add(I, "touchcancel", X)
      .add(I, "contextmenu", X)
      .add(I, "click", an, !0);
  }
  function J() {
    (x.clear(), w.clear(), (B = !1));
  }
  function q() {
    const v = G ? z : u;
    w.add(v, "mousemove", _, E).add(v, "mouseup", X);
  }
  function Z(v) {
    const I = v.nodeName || "";
    return y.includes(I);
  }
  function $() {
    return (p ? A : D)[G ? "mouse" : "touch"];
  }
  function rn() {
    return f.byDistance(0, !1).index !== h.get();
  }
  function ln(v) {
    return f.byDistance(v, !p).distance;
  }
  function Y(v) {
    const I = h.add(yn(v) * -1);
    return p || F(v) < L ? ln(v) : s && rn() ? ln(v) * 0.5 : f.byIndex(I.get(), 0).distance;
  }
  function nn(v) {
    if (!S.createEvent("pointerdown", v).emit()) return;
    const R = Tn(v, C),
      U = R && v.button !== 0;
    ((G = R),
      (j = p && R && !v.buttons && k),
      (k = dn(e.get(), a.get()) >= 2),
      !U &&
        (Z(v.target) ||
          ((H = !0),
          i.pointerDown(v),
          g.useFriction(0).useDuration(0),
          e.set(a),
          (T = i.readPoint(v)),
          (P = i.readPoint(v, m)),
          q(),
          (B = !0))));
  }
  function _(v) {
    if (!S.createEvent("pointermove", v).emit() || (!Tn(v, C) && v.touches.length >= 2))
      return X(v);
    const K = i.readPoint(v),
      on = i.readPoint(v, m),
      sn = dn(K, T),
      Sn = dn(on, P);
    if (!V && !G && (!v.cancelable || ((V = sn > Sn), !V))) return X(v);
    const cn = i.pointerMove(v);
    (sn > d && (j = !0),
      g.useFriction(0.3).useDuration(0.75),
      r.start(),
      e.add(b(cn)),
      v.cancelable && v.preventDefault());
  }
  function X(v) {
    const I = S.createEvent("pointerup", v),
      N = i.pointerUp(v) * $(),
      R = Y(b(N)),
      U = Gn(N, R),
      K = M - 10 * U,
      on = c + U / 50;
    ((V = !1),
      (H = !1),
      (B = !1),
      (G = !1),
      w.clear(),
      g.useDuration(K).useFriction(on),
      l.distance(R, !p),
      I.emit());
  }
  function an(v) {
    j && (v.stopPropagation(), v.preventDefault(), (j = !1));
  }
  function en() {
    return H;
  }
  return { init: W, destroy: J, pointerDown: en };
}
function Un(n) {
  let u, e, i;
  function a(o) {
    u = o;
  }
  function r(o) {
    return o.timeStamp;
  }
  function l(o, p) {
    const s = `client${(p || n.scroll) === "x" ? "X" : "Y"}`;
    return (Tn(o, u) ? o : o.touches[0])[s];
  }
  function g(o) {
    return ((e = o), (i = o), l(o));
  }
  function f(o) {
    const p = l(o) - l(i),
      d = r(o) - r(e) > 170;
    return ((i = o), d && (e = o), p);
  }
  function h(o) {
    if (!e || !i) return 0;
    const p = l(i) - l(e),
      d = r(o) - r(e),
      s = r(o) - r(i) > 170,
      c = p / d;
    return d && !s && F(c) > 0.1 ? c : 0;
  }
  return { init: a, pointerDown: g, pointerMove: f, pointerUp: h, readPoint: l };
}
function Kn(n) {
  function t(e) {
    return n * (e / 100);
  }
  return { measure: t };
}
function Qn(n, t, u, e, i, a) {
  const r = [t, ...e];
  let l,
    g,
    f = [],
    h = !1;
  function S(c) {
    return i.getSize(a.getRect(c));
  }
  function o(c) {
    n &&
      ((g = S(t)),
      (f = e.map(S)),
      (l = new c.ResizeObserver(d)),
      c.requestAnimationFrame(() => {
        r.forEach((m) => l.observe(m));
      }));
  }
  function p() {
    ((h = !0), l && l.disconnect());
  }
  function d(c) {
    const m = u.createEvent("resize", c);
    if (m.emit())
      for (const y of c) {
        if (h) return;
        const E = y.target === t,
          x = e.indexOf(y.target),
          w = E ? g : f[x],
          L = S(E ? t : e[x]);
        if (F(L - w) >= 0.5) {
          m.api.reInit();
          break;
        }
      }
  }
  return { init: o, destroy: p };
}
function Xn() {
  function n(e) {
    const {
      dragHandler: i,
      scrollBody: a,
      scrollBounds: r,
      options: { loop: l },
    } = e;
    (l || r.constrain(i.pointerDown()), a.seek());
  }
  function t(e, i) {
    const {
        scrollBody: a,
        translate: r,
        location: l,
        offsetLocation: g,
        previousLocation: f,
        scrollLooper: h,
        slideLooper: S,
        dragHandler: o,
        animation: p,
        eventHandler: d,
        scrollBounds: s,
        scrollOptimizer: c,
        options: { loop: m },
      } = e,
      b = a.settled(),
      y = !s.shouldConstrain(),
      E = o.pointerDown(),
      w = b && (m || y),
      L = !w,
      D = L && E,
      A = w && !E;
    A && (c.optimize(A), p.stop());
    const M = l.get() * i + f.get() * (1 - i);
    (g.set(M),
      m && (h.loop(a.direction()), S.loop()),
      r.to(g),
      c.optimize(),
      A && d.createEvent("settle", null).emit(),
      L && d.createEvent("scroll", { isDragging: D }).emit());
  }
  return { update: n, render: t };
}
function Wn(n, t, u, e, i, a) {
  let r = 0,
    l = 0,
    g = i,
    f = a,
    h = n.get(),
    S = 0;
  function o() {
    const w = e.minus(n),
      L = !g;
    let D = 0;
    return (
      L
        ? ((r = 0), u.set(e), n.set(e), (D = w))
        : (u.set(n), (r += w / g), (r *= f), (h += r), n.add(r), (D = h - S)),
      (l = yn(D)),
      (S = h),
      x
    );
  }
  function p() {
    const w = e.minus(t);
    return F(w) < 0.001;
  }
  function d() {
    return g;
  }
  function s() {
    return l;
  }
  function c() {
    return r;
  }
  function m() {
    return y(i);
  }
  function b() {
    return E(a);
  }
  function y(w) {
    return ((g = w), x);
  }
  function E(w) {
    return ((f = w), x);
  }
  const x = {
    direction: s,
    duration: d,
    velocity: c,
    seek: o,
    settled: p,
    useBaseFriction: b,
    useBaseDuration: m,
    useFriction: E,
    useDuration: y,
  };
  return x;
}
function Yn(n, t, u, e, i) {
  const { pastAnyBound: a, pastMinBound: r, clamp: l } = n,
    g = i.measure(10),
    f = i.measure(50),
    h = un(0.1, 0.99);
  let S = !1;
  function o() {
    return !(S || !a(u) || !a(t));
  }
  function p(c) {
    if (!o()) return;
    const m = r(t) ? "min" : "max",
      b = F(n[m] - t.get()),
      y = u.minus(t),
      E = h.clamp(b / f);
    (u.subtract(y * E), !c && F(y) < g && (u.set(l(u)), e.useDuration(25).useBaseFriction()));
  }
  function d(c) {
    S = !c;
  }
  return { shouldConstrain: o, constrain: p, toggleActive: d };
}
function _n(n, t, u, e, i) {
  const a = un(-t + n, 0),
    r = S(),
    l = h(),
    g = o();
  function f(d, s) {
    return i ? dn(d, s) <= 1 : !1;
  }
  function h() {
    const d = r[0],
      s = tn(r),
      c = r.lastIndexOf(d),
      m = r.indexOf(s) + 1;
    return un(c, m);
  }
  function S() {
    return u
      .map((d, s) => {
        const { min: c, max: m } = a,
          b = a.clamp(d),
          y = !s,
          E = bn(u, s);
        return y ? m : E || f(c, b) ? c : f(m, b) ? m : b;
      })
      .map((d) => parseFloat(d.toFixed(3)));
  }
  function o() {
    if (t <= n + i) return [a.max];
    if (e === "keepSnaps") return r;
    const { min: d, max: s } = l;
    return r.slice(d, s);
  }
  return { snapsContained: g, scrollContainLimit: l };
}
function Jn(n, t, u) {
  const e = t[0],
    i = u ? e - n : tn(t);
  return { limit: un(i, e) };
}
function Zn(n, t, u, e) {
  const a = t.min + 0.1,
    r = t.max + 0.1,
    { pastMinBound: l, pastMaxBound: g } = un(a, r);
  function f(o) {
    return o === 1 ? g(u) : o === -1 ? l(u) : !1;
  }
  function h(o) {
    if (!f(o)) return;
    const p = n * (o * -1);
    e.forEach((d) => d.add(p));
  }
  return { loop: h };
}
function nt(n) {
  const { max: t, length: u } = n;
  function e(a) {
    const r = a - t;
    return u ? r / -u : 0;
  }
  return { get: Q(e) };
}
function tt(n, t, u, e, i) {
  const { startEdge: a, endEdge: r } = n,
    { groupSlides: l } = i,
    g = S().map(t.measure),
    f = o(),
    h = p();
  function S() {
    return l(e)
      .map((s) => tn(s)[r] - s[0][a])
      .map(F);
  }
  function o() {
    return e.map((s) => u[a] - s[a]).map((s) => -F(s));
  }
  function p() {
    return l(f)
      .map((s) => s[0])
      .map((s, c) => s + g[c]);
  }
  return { snaps: f, snapsAligned: h };
}
function et(n, t, u, e, i, a, r) {
  const { groupSlides: l } = i,
    { min: g, max: f } = e,
    h = d(),
    S = s(),
    o = u.map(r.get),
    p = u.length;
  function d() {
    const m = l(a),
      b = !n || t === "keepSnaps";
    return u.length === 1
      ? [a]
      : b
        ? m
        : m.slice(g, f).map((y, E, x) => {
            const w = !E,
              L = bn(x, E);
            if (w) {
              const D = tn(y);
              return zn(D);
            }
            if (L) {
              const D = mn(a);
              return zn(D, y[0]);
            }
            return y;
          });
  }
  function s() {
    const m = {};
    return (
      h.forEach((b, y) => {
        b.forEach((E) => {
          m[E] = y;
        });
      }),
      m
    );
  }
  return { slidesBySnap: h, snapBySlide: S, progressBySnap: o, length: p };
}
function ot(n, t, u, e, i) {
  const { pastAnyBound: a, removeOffset: r, clamp: l } = e;
  function g(d) {
    return d.sort((s, c) => F(s) - F(c))[0];
  }
  function f(d) {
    const s = n ? r(d) : l(d),
      { index: c } = t.reduce(
        (m, b, y) => {
          const E = F(h(b - s, 0));
          return E >= m.smallestDisplacement ? m : { smallestDisplacement: E, index: y };
        },
        { smallestDisplacement: 1 / 0, index: 0 }
      );
    return { index: c, distance: s };
  }
  function h(d, s) {
    if (!n) return d;
    const c = [d, d + u, d - u];
    if (!s) return g(c);
    const m = c.filter((b) => yn(b) === s);
    return m.length ? g(m) : tn(c) - u;
  }
  function S(d, s) {
    const c = t[d] - i.get(),
      m = h(c, s);
    return { index: d, distance: m };
  }
  function o(d, s) {
    const c = i.plus(d),
      { index: m, distance: b } = f(c),
      y = !n && a(c);
    if (!s || y) return { index: m, distance: d };
    const E = t[m] - b,
      x = d + h(E, 0);
    return { index: m, distance: x };
  }
  return { byDistance: o, byIndex: S, shortcut: h };
}
function st(n, t, u, e, i, a, r) {
  function l(o) {
    const { index: p, distance: d } = o,
      s = t.get(),
      c = p !== s;
    (d && (a.add(d), e.duration() ? n.start() : (n.update(), n.render(1), n.update())),
      c && (u.set(s), t.set(p), r.createEvent("select", { targetSnap: p, sourceSnap: s }).emit()));
  }
  function g(o, p) {
    const d = i.byDistance(o, p);
    l(d);
  }
  function f(o, p) {
    const d = t.clone().set(o).get(),
      s = i.byIndex(d, h(p));
    l(s);
  }
  function h(o) {
    return o ? (vn(o) ? o : o === "forward" ? -1 : 1) : 0;
  }
  return { distance: g, index: f };
}
function rt(n, t, u, e, i, a, r, l, g) {
  const f = { passive: !0, capture: !0 };
  let h = 0;
  function S(s) {
    t &&
      (l.add(s.document, "keydown", p, !1),
      e.forEach((c, m) => {
        l.add(c, "focus", (b) => o(b, m), f);
      }));
  }
  function o(s, c) {
    if (new Date().getTime() - h > 10 || !g.createEvent("slidefocus", s).emit()) return;
    u[n.nativeScroll] = 0;
    const x = i.snapBySlide[c];
    vn(x) && (r.useDuration(0), a.index(x, 0));
  }
  function p(s) {
    s.code === "Tab" && (h = new Date().getTime());
  }
  return { init: S };
}
function fn(n) {
  let t = n || 0;
  function u() {
    return t;
  }
  function e(f) {
    t = f;
  }
  function i(f) {
    t += f;
  }
  function a(f) {
    i(-f);
  }
  function r(f) {
    return t + f;
  }
  function l(f) {
    return r(-f);
  }
  return { get: u, set: Q(e), add: Q(i), subtract: Q(a), plus: Q(r), minus: Q(l) };
}
function it(n, t, u, e, i, a, r, l) {
  const f = pn(e),
    h = pn(e).reverse(),
    S = c().concat(m());
  function o(x, w) {
    return x.reduce((L, D) => L - e[D], w);
  }
  function p(x, w) {
    return x.reduce((L, D) => (o(L, w) > 0 ? [...L, D] : L), []);
  }
  function d(x) {
    return i.map((w, L) => ({ start: w - u[L] + 0.5 + x, end: w + n - 0.5 + x }));
  }
  function s(x, w, L) {
    const D = d(w);
    return x.map((A) => {
      const M = L ? 0 : -t,
        z = L ? t : 0,
        C = L ? "end" : "start",
        k = D[A][C];
      return {
        index: A,
        loopPoint: k,
        slideLocation: fn(-1),
        translate: l[A],
        target: () => (r.get() > k ? M : z),
      };
    });
  }
  function c() {
    const x = a[0],
      w = p(h, x);
    return s(w, t, !1);
  }
  function m() {
    const x = n - a[0] - 1,
      w = p(f, x);
    return s(w, -t, !0);
  }
  function b() {
    return S.every(({ index: x }) => {
      const w = f.filter((L) => L !== x);
      return o(w, n) <= 0.1;
    });
  }
  function y() {
    S.forEach((x) => {
      const { target: w, translate: L, slideLocation: D } = x,
        A = w();
      A !== D.get() && (L.to(A), D.set(A));
    });
  }
  return { canLoop: b, loop: y, loopPoints: S };
}
function ct(n, t, u) {
  let e,
    i = !1;
  function a(f) {
    n && ((e = new f.MutationObserver(l)), e.observe(t, { childList: !0 }));
  }
  function r() {
    (e && e.disconnect(), (i = !0));
  }
  function l(f) {
    const h = u.createEvent("slideschanged", f);
    if (h.emit())
      for (const o of f) {
        if (i) return;
        if (o.type === "childList") {
          h.api.reInit();
          break;
        }
      }
  }
  return { init: a, destroy: r };
}
function ut(n, t, u, e, i) {
  const a = new Set();
  let r,
    l = !1;
  function g(p) {
    ((r = new p.IntersectionObserver(h, { root: n.parentElement, threshold: e, rootMargin: i })),
      t.forEach((d) => r.observe(d)));
  }
  function f() {
    (r && r.disconnect(), (l = !0));
  }
  function h(p) {
    const d = [],
      s = [];
    for (const m of p) {
      if (l) return;
      const b = t.indexOf(m.target);
      m.isIntersecting ? (a.add(b), d.push(b)) : (a.delete(b), s.push(b));
    }
    u.createEvent("slidesinview", {
      slidesInView: S(),
      slidesLeftView: s,
      slidesEnterView: d,
    }).emit();
  }
  function S() {
    return [...a];
  }
  return { init: g, destroy: f, get: S };
}
function lt(n, t, u, e, i, a) {
  const { ownerWindow: r } = a,
    { getSize: l, startEdge: g, endEdge: f } = n,
    h = u[0] && i && r,
    S = s(),
    o = c(),
    p = u.map(l),
    d = m();
  function s() {
    if (!h) return 0;
    const y = u[0];
    return F(t[g] - y[g]);
  }
  function c() {
    if (!h) return 0;
    const y = r.getComputedStyle(tn(e));
    return parseFloat(y.getPropertyValue(`margin-${f}`));
  }
  function m() {
    return u
      .map((y, E, x) => {
        const w = !E,
          L = bn(x, E);
        return w ? p[E] + S : L ? p[E] + o : x[E + 1][g] - y[g];
      })
      .map(F);
  }
  return { slideSizes: p, slideSizesWithGaps: d, startGap: S, endGap: o };
}
function at(n, t, u, e, i, a, r, l, g) {
  const { startEdge: f, endEdge: h, direction: S } = n,
    o = vn(u);
  function p(m, b) {
    return pn(m)
      .filter((y) => y % b === 0)
      .map((y) => m.slice(y, y + b));
  }
  function d(m) {
    return m.length
      ? pn(m)
          .reduce((b, y, E) => {
            const x = tn(b) || 0,
              w = x === 0,
              L = y === mn(m),
              D = i[f] - a[x][f],
              A = i[f] - a[y][h],
              M = !e && w ? S(r) : 0,
              z = !e && L ? S(l) : 0,
              C = F(A - z - (D + M));
            return (E && C > t + g && b.push(y), L && b.push(m.length), b);
          }, [])
          .map((b, y, E) => {
            const x = Math.max(E[y - 1] || 0);
            return m.slice(x, b);
          })
      : [];
  }
  function s(m) {
    return o ? p(m, u) : d(m);
  }
  return { groupSlides: s };
}
function Bn(n, t, u = "px") {
  const e = n.scroll === "x" ? g : f;
  let i = null,
    a = !1,
    r = !1;
  function l(s) {
    i !== s && ((i = s), (t.style.transform = s));
  }
  function g(s) {
    return `translate3d(${s}${u},0px,0px)`;
  }
  function f(s) {
    return `translate3d(0px,${s}${u},0px)`;
  }
  function h(s) {
    if (r || a === s) return;
    a = s;
    const c = s ? e(0) : "";
    l(c);
  }
  function S(s) {
    if (r) return;
    a || h(!0);
    const c = jn(n.direction(s));
    l(e(c));
  }
  function o(s) {
    r = !s;
  }
  function p() {
    (l(""), t.getAttribute("style") || t.removeAttribute("style"));
  }
  return { set: l, clear: p, to: Q(S), get: Q(e), toggleActive: o, setIsScrolling: h };
}
function ft(n, t, u, e, i, a, r, l, g, f, h, S) {
  const p = i ? [0, t, -t] : [0],
    d = w(),
    s = An(e.length - 1, 0, i);
  let c = g.get(),
    m = A(),
    b = m,
    y = [];
  function E(T, P) {
    const B = new Set(P);
    return T.filter((H) => !B.has(H));
  }
  function x(T, P) {
    return p.map((B) => ({ start: P - u[T] + -200 + B, end: P + n - -200 + B }));
  }
  function w() {
    return e.reduce((T, P, B) => Object.assign(Object.assign({}, T), { [B]: x(B, P) }), {});
  }
  function L(T, P) {
    return (B) => d[B].some(({ start: H, end: V }) => H < T && V > P);
  }
  function D(T, P, B, H) {
    const V = T.length > 0,
      j = V ? T[0] : P,
      G = s.clone().set(j),
      W = () => G.add(B).get();
    for (G.set(W()); G.get() !== j; ) {
      const J = G.get(),
        q = H(J);
      if (!q && V) break;
      q && T.push(J);
      const Z = W();
      if ((G.set(Z), i)) continue;
      const $ = !Z,
        rn = bn(e, Z);
      if (($ && B === -1) || (rn && B === 1)) break;
    }
  }
  function A() {
    const T = [],
      P = r.slidesBySnap[a.get()];
    if (!P || !e.length) return T;
    const B = l.get(),
      H = g.get(),
      V = P[Math.floor(P.length / 2)],
      j = Math.max(B, H),
      G = Math.min(B, H),
      W = L(j, G);
    return (W(V) && T.push(V), D(T, V, 1, W), D(T, V, -1, W), T);
  }
  function M(T) {
    ((m = A()), (y = E(b, m)), (b = m), (c = T));
  }
  function z(T, P) {
    P.forEach((B) => {
      const H = f[B],
        V = h.loopPoints[B];
      (i && V && V.target()) || H.setIsScrolling(T);
    });
  }
  function C(T) {
    const P = g.get();
    (!T && P === c) ||
      (M(P), !S.createEvent("scrolloptimize", { slidesInView: m, slidesLeftView: y }).emit()) ||
      (z(!0, m), z(!1, y));
  }
  return { optimize: C };
}
function dt(n, t, u, e, i, a, r, l) {
  const {
      align: g,
      axis: f,
      direction: h,
      startSnap: S,
      loop: o,
      duration: p,
      dragFree: d,
      dragThreshold: s,
      inViewThreshold: c,
      inViewMargin: m,
      slidesToScroll: b,
      skipSnaps: y,
      containScroll: E,
      draggable: x,
      resize: w,
      slideChanges: L,
      focus: D,
    } = e,
    A = l ? 0 : 2,
    M = Vn(f, h),
    { containerRect: z, slideRects: C } = r,
    k = M.getSize(z),
    T = Kn(k),
    P = $n(g, k),
    B = !o && !!E,
    H = o || !!E,
    { slideSizes: V, slideSizesWithGaps: j, startGap: G, endGap: W } = lt(M, z, C, u, H, i),
    J = at(M, k, b, o, z, C, G, W, A),
    { snaps: q, snapsAligned: Z } = tt(M, P, z, C, J),
    $ = -tn(q) + tn(j),
    { snapsContained: rn, scrollContainLimit: ln } = _n(k, $, Z, E, A),
    Y = B ? rn : Z,
    { limit: nn } = Jn($, Y, o),
    _ = An(mn(Y), S, o),
    X = _.clone(),
    an = pn(u),
    en = Xn(),
    O = Rn(
      () => en.update(Ln),
      (In) => en.render(Ln, In)
    ),
    v = 0.68,
    I = Y[_.get()],
    N = fn(I),
    R = fn(I),
    U = fn(I),
    K = fn(I),
    on = Bn(M, t),
    sn = u.map((In) => Bn(M, In)),
    Sn = nt(nn),
    cn = Wn(N, U, R, K, p, v),
    En = et(B, E, Y, ln, J, an, Sn),
    On = it(k, $, V, j, q, Y, U, sn),
    Cn = ft(k, $, j, q, o, _, En, U, K, sn, On, a),
    xn = ot(o, Y, $, nn, K),
    wn = st(O, _, X, cn, xn, K, a),
    Mn = gn(),
    Hn = ut(t, u, a, c, m),
    kn = rt(M, D, n, u, En, wn, cn, Mn, a),
    Ln = {
      eventHandler: a,
      containerRect: z,
      contentSize: $,
      slideRects: C,
      nodeHandler: i,
      animation: O,
      slideSizes: V,
      isSsr: l,
      axis: M,
      dragHandler: qn(x, M, n, K, Un(M), N, O, wn, cn, xn, _, a, T, d, s, y, v),
      eventStore: Mn,
      percentOfView: T,
      indexCurrent: _,
      indexPrevious: X,
      limit: nn,
      location: N,
      offsetLocation: U,
      previousLocation: R,
      options: e,
      resizeHandler: Qn(w, t, a, u, M, i),
      scrollBody: cn,
      scrollBounds: Yn(nn, U, K, cn, T),
      scrollLooper: Zn($, nn, U, [N, U, R, K]),
      scrollProgress: Sn,
      scrollSnaps: Y,
      scrollTarget: xn,
      scrollTo: wn,
      slideLooper: On,
      slideFocus: kn,
      slidesHandler: ct(L, t, a),
      slidesInView: Hn,
      slideIndexes: an,
      slidesToScroll: J,
      slideTranslates: sn,
      scrollSnapList: En,
      scrollOptimizer: Cn,
      translate: on,
      target: K,
    };
  return Ln;
}
function pt() {
  let n = {},
    t;
  function u(o) {
    t = o;
  }
  function e(o) {
    return n[o] || [];
  }
  function i(o, p) {
    return ((n = Object.assign(Object.assign({}, n), { [o]: p(e(o)) })), S);
  }
  function a(o, p) {
    return { api: t, type: o, detail: p };
  }
  function r(o, p) {
    return { api: t, emit: () => l(o, p) };
  }
  function l(o, p) {
    const d = a(o, p);
    return e(o).every((s) => s(t, d) !== !1);
  }
  function g(o, p) {
    return (i(o, (d) => (d.includes(p) ? d : [...d, p])), S);
  }
  function f(o, p) {
    return (i(o, (d) => d.filter((s) => s !== p)), S);
  }
  function h() {
    n = {};
  }
  const S = { init: u, clear: h, createEvent: r, on: g, off: f };
  return S;
}
const gt = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  inViewMargin: "0px",
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startSnap: 0,
  active: !0,
  draggable: !0,
  resize: !0,
  focus: !0,
  slideChanges: !0,
  ssr: [],
};
function mt(n) {
  const t = n ? n.ownerDocument : null,
    u = t ? t.defaultView : null;
  let e;
  function i(S) {
    const { offsetTop: o, offsetLeft: p, offsetWidth: d, offsetHeight: s } = S;
    return { top: o, right: p + d, bottom: o + s, left: p, width: d, height: s };
  }
  function a(S, o, p) {
    if (p && e) return e;
    const d = n ? S.style : { transform: "" },
      s = d.transform;
    d.transform = "none";
    const c = i(S),
      m = o.map(i);
    return ((d.transform = s), (e = { containerRect: c, slideRects: m }), e);
  }
  function r(S, o, p, d) {
    return { offsetLeft: S, offsetTop: o, offsetWidth: p, offsetHeight: d };
  }
  function l(S) {
    const { container: o, slides: p } = S,
      s = (Dn(o) ? n.querySelector(o) : o) || n.children[0],
      c = Dn(p) ? s.querySelectorAll(p) : p,
      m = Array.from(c || s.children);
    return { root: n, container: s, slides: m };
  }
  function g(S) {
    const p = r(0, 0, 100, 100),
      d = p;
    let s = 0;
    const c = S.ssr.map((m) => {
      const b = r(s, s, m, m);
      return ((s += m), b);
    });
    return { root: p, container: d, slides: c };
  }
  function f(S) {
    return n ? l(S) : g(S);
  }
  return { ownerDocument: t, ownerWindow: u, getNodes: f, getRect: i, getRects: a };
}
function St() {
  let n;
  function t(r) {
    r && (n = r);
  }
  function u(r, l) {
    return Nn(r, l || {});
  }
  function e(r) {
    if (!n) return r;
    const l = r.breakpoints || {},
      g = hn(l)
        .filter((f) => n.matchMedia(f).matches)
        .map((f) => l[f])
        .reduce((f, h) => u(f, h), {});
    return u(r, g);
  }
  function i(r) {
    return n
      ? r
          .map((l) => hn(l.breakpoints || {}))
          .reduce((l, g) => l.concat(g), [])
          .map(n.matchMedia)
      : [];
  }
  return { init: t, mergeOptions: u, optionsAtMedia: e, optionsMediaQueries: i };
}
function ht(n) {
  let t = [];
  function u(a, r) {
    return (
      (t = r),
      r.reduce((l, g) => (g.init(a, n), Object.assign(Object.assign({}, l), { [g.name]: g })), {})
    );
  }
  function e() {
    t = t.filter((a) => a.destroy());
  }
  return { init: u, destroy: e };
}
function vt(n, t, u, e, i, a) {
  const r = Bn(t, n, "%");
  function l(h, S, o) {
    const { direction: p } = Vn(h.axis, h.direction),
      { slides: d, container: s } = u.getNodes(h),
      { location: c, slideLooper: m, contentSize: b } = a(h, s, d),
      y = h.loop ? m.loopPoints : [],
      E = p(c),
      x = r.get(E),
      w = `${S}{transform:${x};}`,
      L = y.reduce((D, A) => {
        const { index: M } = A,
          z = yn(A.target()),
          C = h.ssr[M];
        if (!z || !C) return D;
        const k = p((b / C) * 100 * z),
          T = r.get(k);
        return D + `${S} ${o}:nth-child(${M + 1}){transform:${T};}`;
      }, "");
    return w + L;
  }
  function g(h, S = "> *") {
    if (!e.ssr.length) return "";
    const o = e.breakpoints || {},
      p = l(e, h, S),
      d = Object.keys(o).reduce((s, c) => {
        const m = i(e, o[c]);
        return s + `@media ${c}{${l(m, h, S)}}`;
      }, "");
    return p + d;
  }
  return { getStyles: g };
}
function Fn(n, t, u) {
  const e = !n,
    i = St(),
    a = ht(i),
    r = gn(),
    l = pt(),
    { mergeOptions: g, optionsAtMedia: f, optionsMediaQueries: h } = i,
    { on: S, off: o, createEvent: p } = l,
    d = k;
  let s = !1,
    c,
    m,
    b,
    y = g(gt, Fn.globalOptions),
    E = g(y),
    x = [],
    w = {},
    L,
    D,
    A;
  function M(O) {
    const v = g(E, O);
    return z(v, D, A, !0);
  }
  function z(O, v, I, N) {
    const U = g(O, e ? { direction: "ltr" } : {}),
      K = m.getRects(v, I, N),
      on = dt(L, v, I, U, m, l, K, e);
    if (O.loop && !on.slideLooper.canLoop()) {
      const sn = g(O, { loop: !1 });
      return z(sn, v, I, !0);
    }
    return on;
  }
  function C(O, v) {
    if (s) return;
    m = mt(n);
    const { ownerWindow: I } = m;
    (i.init(I), (y = g(y, O)), (E = f(y)), (x = v || x));
    const N = m.getNodes(E);
    ((L = N.root),
      (D = N.container),
      (A = N.slides),
      (c = z(E, D, A)),
      (b = vt(D, c.axis, m, y, g, z)),
      h([y, ...x.map(({ options: R }) => R)]).forEach((R) => r.add(R, "change", k)),
      E.active &&
        (!e &&
          I &&
          (c.translate.to(c.location),
          c.scrollOptimizer.optimize(!0),
          c.options.loop && c.slideLooper.loop(),
          c.animation.init(I),
          c.resizeHandler.init(I),
          c.slidesInView.init(I),
          c.slidesHandler.init(I),
          c.slideFocus.init(I),
          c.eventHandler.init(en),
          D.offsetParent && A.length && c.dragHandler.init(I)),
        (w = a.init(en, x))));
  }
  function k(O, v) {
    const I = l.createEvent("reinit", null),
      N = $();
    (T(), C(g({ startSnap: N }, O), v), I.emit());
  }
  function T() {
    (c.dragHandler.destroy(),
      c.resizeHandler.destroy(),
      c.slidesHandler.destroy(),
      c.slidesInView.destroy(),
      c.animation.destroy(),
      a.destroy(),
      c.eventStore.clear(),
      r.clear(),
      c.translate.clear(),
      c.slideTranslates.forEach((O) => O.clear()));
  }
  function P() {
    if (s || e) return;
    const O = l.createEvent("destroy", null);
    ((s = !0), r.clear(), T(), O.emit(), l.clear());
  }
  function B(O, v, I) {
    s ||
      e ||
      (E.active &&
        (c.scrollBody.useBaseFriction().useDuration(v === !0 ? 0 : E.duration),
        c.scrollTo.index(O, I)));
  }
  function H(O) {
    B(q(1), O, -1);
  }
  function V(O) {
    B(q(-1), O, 1);
  }
  function j() {
    return q(1) !== $();
  }
  function G() {
    return q(-1) !== $();
  }
  function W(O, v) {
    return e ? b.getStyles(O, v) : "";
  }
  function J() {
    return c.scrollProgress.get(c.offsetLocation);
  }
  function q(O) {
    return c.indexCurrent.add(O).get();
  }
  function Z() {
    return c.scrollSnapList.progressBySnap;
  }
  function $() {
    return q(0);
  }
  function rn() {
    return c.indexPrevious.get();
  }
  function ln() {
    return c.slidesInView.get();
  }
  function Y() {
    return w;
  }
  function nn() {
    return c;
  }
  function _() {
    return L;
  }
  function X() {
    return D;
  }
  function an() {
    return A;
  }
  const en = {
    canGoToNext: j,
    canGoToPrev: G,
    cloneEngine: M,
    containerNode: X,
    createEvent: p,
    internalEngine: nn,
    destroy: P,
    on: S,
    off: o,
    plugins: Y,
    previousSnap: rn,
    reInit: d,
    rootNode: _,
    goToNext: H,
    goToPrev: V,
    scrollProgress: J,
    goTo: B,
    selectedSnap: $,
    slideNodes: an,
    slidesInView: ln,
    snapIndex: q,
    snapList: Z,
    ssrStyles: W,
  };
  return (C(t || {}, u || []), en);
}
Fn.globalOptions = void 0;
export { Fn as E };
